import type { IChartRange } from '~/types'
import { useRuntimeConfig } from 'nuxt/app'

export const getSiteNames = () => {
  const config = useRuntimeConfig()
  return {
    ru: config.public.siteNameRu,
    ky: config.public.siteNameKy
  }
}

export const CHART_DATE_RANGES: IChartRange[] = [
  { key: 'lastMonth', label: '1m' },
  { key: 'last3Months', label: '3m' },
  { key: 'last6Months', label: '6m' },
  { key: 'fromBeginningOfYear', label: 'YTD' },
  { key: 'lastYear', label: '1y' },
  { key: 'allTime', label: 'All' }
]

export const ANCHOR_IDS = {
  FEATURE_BANK_PAGE_FORM_SUPPORT: 'support-form',
  FEATURE_CONTACT_PAGE_FORM: 'contact-page-form',
  FEATURE_CREDIT_CALCULATOR: 'credit-calculator',
  FEATURE_DEPOSIT_CALCULATOR: 'deposit-calculator',
  FEATURE_CREDIT_FORM_REQUEST: 'lead-request-form',
  FEATURE_CARD_FORM_REQUEST: 'lead-request-form',
  FEATURE_DEPOSIT_FORM_REQUEST: 'lead-request-form',
  WIDGET_RATING: 'rating',
  WIDGET_COMMENTS: 'comments',
  WIDGET_RATES_CONVERTER: 'rates-converter',
  WIDGET_MARKET_MONITOR: 'market-monitor'
} as const
